import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "simba_admin_token";

// Use sessionStorage so the admin token is cleared when the tab closes and is
// not shared across browser sessions — reduces XSS-driven token-theft blast radius.
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);
export const setToken = (t) => sessionStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => sessionStorage.removeItem(TOKEN_KEY);
export const isAuthed = () => !!getToken();

const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const adminLogin = async (password) => {
  const res = await axios.post(`${API}/admin/login`, { password });
  setToken(res.data.token);
  return res.data;
};

export const verifyToken = async () => {
  const res = await axios.get(`${API}/admin/me`, { headers: authHeaders() });
  return res.data;
};

export const adminListEnquiries = async (type = "") => {
  const url = type ? `${API}/admin/enquiries?enquiry_type=${encodeURIComponent(type)}` : `${API}/admin/enquiries`;
  const res = await axios.get(url, { headers: authHeaders() });
  return res.data;
};

export const adminDeleteEnquiry = async (id) => {
  const res = await axios.delete(`${API}/admin/enquiries/${id}`, { headers: authHeaders() });
  return res.data;
};

export const adminListContent = async (collection) => {
  const res = await axios.get(`${API}/admin/content/${collection}`, { headers: authHeaders() });
  return res.data.items;
};

export const adminUpsertContent = async (collection, slug, data) => {
  const res = await axios.put(
    `${API}/admin/content/${collection}/${encodeURIComponent(slug)}`,
    data,
    { headers: authHeaders() },
  );
  return res.data;
};

export const adminDeleteContent = async (collection, slug) => {
  const res = await axios.delete(
    `${API}/admin/content/${collection}/${encodeURIComponent(slug)}`,
    { headers: authHeaders() },
  );
  return res.data;
};

export const adminListAgentRegistrations = async () => {
  const res = await axios.get(`${API}/admin/agent-registrations`, { headers: authHeaders() });
  return res.data;
};

export const adminDeleteAgentRegistration = async (id) => {
  const res = await axios.delete(`${API}/admin/agent-registrations/${id}`, { headers: authHeaders() });
  return res.data;
};
